import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { User } from '../models/user.model';
import { UserState } from './user.reducers';
import { usersQuery } from './user.selectors';
import {
  fetchUsersRequest,
  createUsersRequest,
  deleteUsersRequest,
} from './user.actions';

@Injectable()
export class UserFacade {
  constructor(private store: Store<UserState>) {}

  public users$ = this.store.select(usersQuery.getUsers);
  public isFetching$ = this.store.select(usersQuery.getIsFetching);

  fetchUsers() {
    this.store.dispatch(fetchUsersRequest());
  }

  createUser(payload: User) {
    this.store.dispatch(createUsersRequest({ payload }));
  }

  deleteUsers(payload: { ids: number[] }) {
    this.store.dispatch(deleteUsersRequest({ payload }));
  }
}
